export default {
  recommendedShopsTitle: {
    gb: 'Browse More Gear from Top Shops in the UK',
    inCountry: 'Browse More Gear from Top Shops in {{country}}',
    default: 'Browse Top Shops',
  },
};
